import React from 'react'
import { Button, Alert, Input, Form, Checkbox, Select, Radio, Switch, Popconfirm, Row } from 'antd';
import { Field, reduxForm, FieldArray } from 'redux-form'
// SHARED
import { Icon, PlusIcon } from '../../core/icons'
import Card, { TitleCard, CardHeader } from '../../core/Card'
// LOCAL
import './Vehicle.css'
import makeField from '../makeField'
import moment from 'moment'

const Option = Select.Option;

const AInput = makeField(Input);
const ASelect = makeField(Select);
const ASwitch = makeField(Switch);
const iconNames = [
  // 'Pioneer Wagon',
  'Wagon',
  // 'Launched Rocket',
  'Rocket',
  // 'Prop Plane',
  'PropPlane',
  // 'Go Kart',
  'GoKart',
  // 'F1 Race Car Side View',
  'RaceCar',
  'Convertible',
  'Pickup',
  'Truck',
  'Sedan',
  // 'E-Unicycle',
]

const renderYears = ({ fields, meta: { error } }) => (
  <div>
    <CardHeader
      title="Odometer Readings"
      buttonTitle="Add Year"
      buttonOnClick={() => fields.push()}
    />
    <ul>
      {fields.map((year, index) => (
        <li key={index}>
          {/*<button
            type="button"
            title="Remove Year"
            onClick={() => fields.remove(index)}
          />*/}
          <Field
            name={year}
            type="text"
            component={AInput}
            label={`${moment().format('YYYY') - index}`}
          />
        </li>
      ))}
      {error && <li className="error">{error}</li>}
    </ul>
  </div>
)

const limitFour = (value, previousValue, allValues) => value.length<5 ? value : previousValue

const Vehicle = ({ disabled, onRemoteSubmit, submitSucceeded, submitFailed, error, onDelete, title, buttonTitle, pristine, reset, submitting }) => {
  return (
    <div className="Vehicle">
      <TitleCard showBackButton>
        <h1>{title}</h1>

          {/*{ (submitSucceeded && !submitting) ? <Alert message="Vehicle saved successfully." type="success" /> : null}*/}
          { (submitFailed && !submitting) ? <Alert message="Saving failed." type="error" /> : null}

          <Button loading={submitting} disabled={pristine || disabled} onClick={onRemoteSubmit} type="primary">{buttonTitle}</Button>
          { onDelete &&
            <Popconfirm title="Are you sure?" placement="left" onConfirm={onDelete} okText="Yes" cancelText="No">
              <Button type="danger" icon="delete"></Button>
            </Popconfirm>
            }

      </TitleCard>

      <Card>
        <CardHeader
          title="Vehicle Information"
        />

        <Field
          name="primary"
          type="checkbox"
          component={ASwitch}
          label="Primary Vehicle"
        />

        <Field
          name="make"
          type="text"
          component={AInput}
          label="Make"
        />

        <Field
          name="model"
          type="text"
          component={AInput}
          label="Model"
        />

        <Field
          name="year"
          type="number"
          normalize={limitFour}
          component={AInput}
          label="Year"
        />

        <Field
          name="nickname"
          type="text"
          component={AInput}
          label="Nickname"
        />

        <Field
          name="insurance_company"
          type="text"
          component={AInput}
          label="Insurance Company"
        />

        <Field
          name="insurance_cost_monthly"
          type="number"
          component={AInput}
          label="Monthly Insurance Rate"

        />

        <Field
          name="icon_name"
          type="input"
          component={ASelect}
          label="Icon"
          formLayout="horizontal"
          dropdownClassName="vehicles-icon-dropdown"
        >
          {iconNames.map(name=>
            <Option value={name}>
              <Row type="flex" justify="space-between" align="middle">
                <Icon type={name}/>
                <div>{name}</div>
              </Row>
            </Option>
          )}
        </Field>

        {/* <Field
          name="electric"
          type="checkbox"
          component={ASwitch}
          label="Electric / Hybrid"
        /> */}

      </Card>

      <Card>

        <FieldArray name="odometer_readings" component={renderYears} />

      </Card>
    </div>
  )
}

export default Vehicle



// WEBPACK FOOTER //
// ./src/account/vehicles/Vehicle.jsx